module.exports = __webpack_public_path__ + "static/media/image 6.a3fc33fe.png";